<template>
    <input id="titleFont">
</template>

<script>
    export default {
        mounted() {
            var self = this
            $('#titleFont').fontselect().change(function() {
            var titleFont = $(this).val().replace(/\+/g, ' ');
                titleFont = titleFont.split(':');
                  self.$emit('get-font-title', titleFont[0]);
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/JQueryPluggins/FontTitle.vue